import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import footballIcon from "../../assets/images/icons/football_icon.svg";
import rugbyIcon from "../../assets/images/icons/rugby_icon.svg";
import ClubbieButton from "../../components/ClubbieButton/ClubbieButton";
import { updateTournamentSport } from "../../redux/slices/tournamentSlice";
import { DASHBOARD_STACK } from "../../utils/screenNames";
import SPORT_TYPES from "../../utils/sportTypes";
import { tournamentWizardStepCompleted } from "../../utils/analytics";
import { WIZARD_STEP } from "../../utils/analyticsEvents";
import "./ChooseSport.css";

const ChooseSport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );
  const [selectedSport, setSelectedSport] = useState(
    selectedTournament?.sport || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedTournament?.sport) {
      setSelectedSport(selectedTournament.sport);
    }
  }, [selectedTournament]);

  const handleNext = async () => {
    try {
      if (selectedSport && selectedTournament) {
        setIsLoading(true);
        const result = await dispatch(
          updateTournamentSport({
            tournamentId: selectedTournament?.id,
            updateData: { sport: selectedSport },
          })
        );

        if (result.meta.requestStatus === "fulfilled") {
          toast.success("Sport updated successfully!");
        } else {
          throw new Error("Failed to update sport");
        }
      }

      tournamentWizardStepCompleted({
        stepName: WIZARD_STEP.CHOOSE_SPORT,
        tournamentId: selectedTournament?.id,
      });
      navigate(DASHBOARD_STACK.CREATE_TOURNAMENT.CHOOSE_RESULT_MANAGEMENT);
    } catch (error) {
      toast.error(error.message || "Failed to update sport");
    } finally {
      setIsLoading(false);
    }
  };

  const sports = [
    { id: SPORT_TYPES.FOOTBALL, name: "Football", icon: footballIcon },
    // { id: SPORT_TYPES.RUGBY, name: "Rugby", icon: rugbyIcon },
    { id: SPORT_TYPES.TOUCH_RUGBY, name: "Touch Rugby", icon: rugbyIcon },
  ];

  return (
    <>
      <div className="input-section">
        <p>Choose Sport</p>
        <div className="sports-container">
          {sports.map((sport) => (
            <button
              key={sport.id}
              className={`sport-option ${selectedSport === sport.id ? "selected" : ""}`}
              onClick={() => setSelectedSport(sport.id)}
              type="button"
            >
              <div className="sport-radio" />
              <img src={sport.icon} alt={sport.name} className="sport-icon" />
              <span>{sport.name}</span>
            </button>
          ))}
        </div>
      </div>

      <ClubbieButton
        className="next-button"
        onClick={handleNext}
        disabled={isLoading || !selectedSport}
        isLoading={isLoading}
      >
        Next
      </ClubbieButton>
    </>
  );
};

export default ChooseSport;
